import type {
  ContactCategory,
  TechnicalIssueType,
} from "@/constants/contactForm";

export const requiresAudioReviewConsent = ({
  category,
  technicalIssueType,
}: {
  category: ContactCategory;
  technicalIssueType: TechnicalIssueType | undefined;
}): boolean => {
  return (
    category === "technical" &&
    (technicalIssueType === "voice_quality" ||
      technicalIssueType === "audio_file_format" ||
      technicalIssueType === "voice_model")
  );
};
